<template>
  <!-- Top navigation -->
  <DetailTopNav :heading="this.viewType" :subheading="this.assetType" />

  <div
    class="position-absolute v-content d-flex align-items-center text-center z-1"
  >
    <div class="h-100 w-100">
      <iframe
        :src="this.assetUrls[this.order]"
        :title="this.assetNames[this.order]"
        width="100%"
        height="100%"
        allow="fullscreen"
      ></iframe>
    </div>
  </div>

  <OffCanvas />
</template>

<script>
import DetailTopNav from '@/components/DetailTopNav.vue'

import OffCanvas from '@/components/OffCanvas.vue'
import global from '../global'

export default {
  name: 'AssetViewDetail',
  props: ['assetType', 'viewType', 'order'],
  components: {
    DetailTopNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      assetOrder: null,
      currentAsset: null,
      folderStructure: encodeURIComponent(
        this.theme.devFolder +
          '/assets/' +
          this.assetType +
          '/' +
          this.viewType +
          '/'
      ),
      currentIndex: null,
      assetNames: null,
      assetUrls: null,
      componentName: 'AssetView',
      assetTypesReady: false,
    }
  },
  created() {
    if (this.viewType === '3-Bed') {
      this.assetOrder = this.theme.bedAsset.balconyViews
      this.assetNames = this.theme.bedAsset.balconyViewsName
      this.assetUrls = this.theme.bedAsset.balconyViewsUrl
    } else if (this.assetType === 'Rana') {
      this.assetOrder = this.theme.RanaAsset.balconyViews
      this.assetNames = this.theme.RanaAsset.balconyViewsName
      this.assetUrls = this.theme.RanaAsset.balconyViewsUrl
    }
  },
  methods: {},
  setup() {
    const { theme } = global

    return {
      theme,
    }
  },
}
</script>
